export default (params) => ({
  trigger: {
    name: 'review_panel.filter_reviews',
    params: params,
  },
  config: {
    schema: {
      filter_name: {
        type: 'string',
      },
      filter_value: {
        type: 'string',
      },
    },
    event: {
      name: 'select_filter',
      params: {
        sub_feature: null,
        is_recommended: null,
        number_of_items: null,
      },
    },
  },
});
